



























import Navigation from '@/components/Navigation'
import DocumentLink from '@/components/DocumentLink'

export default {
    name: 'MobileNavigation'

    extends: Navigation

    watch:
        $route: (to, from) ->
            UIkit.modal(@$el).hide()
}
